import { jsx as _jsx } from "react/jsx-runtime";
import { useClassified } from "@/contexts/classified";
import { useSellerLeadLink } from "../Sections/SellerLeadTeaser";
import { SimilarListings } from "./SimilarListings";
export const SimilarListingSSR = () => {
    var _a, _b, _c;
    const similarListings = (_c = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.similarListings) === null || _b === void 0 ? void 0 : _b.filter((card) => card.status === "Published")) !== null && _c !== void 0 ? _c : null;
    const similarRecords = (similarListings !== null && similarListings !== void 0 ? similarListings : [])
        .filter((card) => Object.keys(card).length > 1)
        .reduce((acc, card) => (Object.assign(Object.assign({}, acc), { [card.id]: card })), {});
    const isDisplayed = !!(similarListings === null || similarListings === void 0 ? void 0 : similarListings.length);
    const { funnel: funnelUrl } = useSellerLeadLink();
    return (_jsx(SimilarListings, { similarListings: similarListings, similarRecords: similarRecords, isDisplayed: isDisplayed, funnelUrl: funnelUrl || null, isErrorPageDisplay: true }));
};
